document.addEventListener("DOMContentLoaded", function () {
  const element = document.querySelector("[data-component=connect-account-page]");
  if (!element) return;

  const SESSION_KEY = "japanhaul.connectPortalBaseUrl";

  // The portal links here with ?to=<callback URL>. Keep it in sessionStorage
  // because Shopify drops the query string on the login round-trip.
  const toParam = new URLSearchParams(window.location.search).get("to");
  if (toParam) sessionStorage.setItem(SESSION_KEY, toParam);

  const baseUrl = sessionStorage.getItem(SESSION_KEY);

  const connectButton = element.querySelector("[data-action=connect-now]");
  if (connectButton) {
    if (baseUrl) {
      connectButton.href = baseUrl + "&customer_id=" + connectButton.dataset.customerId;
      connectButton.hidden = false;
    } else {
      const message = element.querySelector("[data-message=missing-callback]");
      if (message) message.hidden = false;
    }
  }

  element.querySelectorAll("[data-show-form]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const form = element.querySelector("[data-form=" + link.dataset.showForm + "]");
      if (form) form.hidden = false;
    });
  });

  // Same mechanism as cp-login.js: after a successful portal login the CP
  // iframe posts the generated Shopify credentials, which are submitted
  // through the hidden native login form to start the Shopify session.
  window.addEventListener("message", function (event) {
    if (event.data && event.data.type === "login") {
      localStorage.setItem("ichigo_admin_user", event.data.serialized_user);
      localStorage.setItem("ichigo_admin_token", event.data.token);

      const emailInput = document.querySelector("#CustomerLoginForm #CustomerEmail");
      const passwordInput = document.querySelector("#CustomerLoginForm #CustomerPassword");
      const form = document.querySelector("#CustomerLoginForm form");

      if (emailInput) emailInput.value = event.data.email;
      if (passwordInput) passwordInput.value = event.data.generated_password;
      if (form) form.submit();
    }
  });
});
